// Kept apart from UiScenarioApp so importing the check never pulls the scenario app into a chunk.
export const isLocalUiScenario = () => {
  if (
    import.meta.env.MODE !== 'development'
    || (import.meta.env.VITE_IA_ENV && import.meta.env.VITE_IA_ENV !== 'local')
  ) {
    return false;
  }

  return localStorage.getItem('ui_scenario') === 'true';
};
